export const CREATE_SA_BIGQUERY_NAME = "create_search_analytics_bigquery";
export const CREATE_SA_BIGQUERY_DESC = `Registers a Search Analytics BigQuery table configuration for a workspace (Organization).

Use when the user wants to connect Search Analytics to BigQuery via:
- SELF: customer-managed GCP project + dataset
- JADE: Amethyst-managed bulk-export dataset (recommended default when export is available)
- API: GSC API connection into an Amethyst-managed dataset (when bulk export is unavailable or undesirable)

Input:
- 'manageType' (optional): 'SELF' | 'JADE' | 'API'. Default to 'SELF'. Use 'SELF' whenever the user provides projectID or datasetName. Use 'API' with propertyID for GSC API connection.
- 'projectID' (required for SELF): Google Cloud project ID for BigQuery (string).
- 'datasetName' (required for SELF): BigQuery dataset name.
- 'propertyID' (required for API): registered Search Console property ID (user login property or workspace service-account property).
- 'backfillMonths' (optional for API): 3 | 6 | 12 | 16. Defaults to 16.
- Provide workspace scope with exactly one of:
  - 'organizationId': Organization / workspace ID, OR
  - 'projectId': Search Analytics Project ID (the tool resolves the organization from linked Search Analytics).

Notes:
- Write operation (mutation). Requires confirmation.
- If only projectId is given, the tool loads Search Analytics on that project and derives organizationId.
- Never use 'JADE' when the user provides a GCP project or dataset; JADE creates an Amethyst-managed dataset with a generated name.
- API connection limitations: no Search Appearances; site capture rate may be below 100%. Prefer JADE when bulk export is available.
- API creation requires the organization feature flag gsc_api_connector when it is still in pilot.
- After registration, Search Analytics can use this BigQuery configuration (see list_bigquery).`;
